




















































import {Component, Vue, Prop} from "vue-property-decorator";
import axios from "axios";

@Component({components: {}})
export default class audit_detail extends Vue {
    auth = sessionStorage.getItem('auth');
    loading = false;
    $config: any;
    summit = true;
    multi_name = '';

    @Prop({
        type: Boolean,
        required: true,
        default: false
    }) public is_open !: boolean;

    @Prop({
        type: Array,
        required: true,
        default: false
    }) public sql_columns !: object;

    @Prop({
        type: Boolean,
        required: true,
        default: false
    }) public multi !: boolean;

    @Prop({
        type: Array,
        required: true,
        default: []
    }) public multi_list !: object;

    get open() {
        return this.is_open
    }

    set open(vl) {

    }

    get formItem() {
        return this.$store.state.order_item;
    }

    get sql_data () {
        return this.$store.state.order_sql;
    }

    set sql_data (vl) {
        this.$store.state.order_sql = vl;
    }

    reject() {
        this.$emit("reject")
    }

    agreed() {
        this.$emit("agreed", this.multi_name, this.formItem.WorkId)
    }

    perform() {
        this.$emit("perform", this.formItem.WorkId)
    }

    cancel() {
        this.$emit("cancel");
        this.summit = true
    }

    testTo() {
        this.loading = true;
        let s = '';
        for (let i of this.sql_data) {
            s += i.SQL
        }
        let isDML = false;
        if (this.formItem.Type === 1) {
            isDML = true
        }
        axios.put(`${this.$config.url}/fetch/test`, {
            'source': this.formItem.Source,
            'database': this.formItem.Base,
            'table': this.formItem.Table,
            'sql': s,
            'isDMl': isDML
        })
            .then(res => {
                this.sql_data = res.data;
                let gen = 0;
                this.sql_data.forEach((vl: { Level: number; }) => {
                    if (vl.Level !== 0) {
                        gen += 1
                    }
                });
                this.summit = gen !== 0;
                this.loading = false
            })
            .catch(error => {
                    this.$config.err_notice(this,error)
                })
    }
}
